window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function (data) {
    data.search.configs.general.minQueryLength = 1;
    return data;
});

window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function (data) {
    data.search.configs.general.minQueryLength = 1;
    return data;
});

window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function (data) {
    data.minQueryLength = 1;
    return data;
});
window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function (products) {
    if (!products || !products.length) return products;

    products.forEach(function (product) {
      var categoryName = (product.categories && product.categories[0] && product.categories[0].name) ? product.categories[0].name.toLowerCase() : '';
      var url = product.url || '';

      if (categoryName === 'blogs' || url.includes('/blogs/')) {
        product.isBlogOrPage = true;
        product.resultType = 'Blog';
        product.displayAddToCart = false;
        product.displayAddtoCart = false;
      } else if (categoryName === 'pages' || url.includes('/pages/')) {
        product.isBlogOrPage = true;
        product.resultType = 'Page';
        product.displayAddToCart = false;
        product.displayAddtoCart = false;
      }

      // ✅ Check if image is missing or placeholder
      var img = product.mainImage || '';
      if (!img || img.trim() === '' || img.includes('placeholder') || img.includes('no-image')) {
        product.hasNoImage = true;
      }
    });

    return products;
});




  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      if (data.api !== "autocomplete") return data;

      const query = window.wizzyConfig?.pageStore?.searchInputValue?.trim();
      if (!query) {
        sessionStorage.removeItem("wizzy_suggestions_cache");
        return data;
      }

      const pages = data?.response?.payload?.pages || [];
      if (!pages.length) {
        sessionStorage.removeItem("wizzy_suggestions_cache");
        return data;
      }

      const pageSuggestions = pages
        .map(item => item?.filters?.pages?.[0])
        .filter(Boolean)
        .map(page => ({
          slug: page.slug,
          title: page.title,
          url: page.url
        }));

      if (!pageSuggestions.length) {
        sessionStorage.removeItem("wizzy_suggestions_cache");
        return data;
      }

      // ONLY ONE QUERY — overwrite completely
      sessionStorage.setItem(
        "wizzy_suggestions_cache",
        JSON.stringify({
          [query]: pageSuggestions
        })
      );

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
  function (data) {

    const query = window.wizzyConfig?.pageStore?.searchInputValue?.trim();
    if (!query) return data;

    let cache;
    try {
      cache = JSON.parse(
        sessionStorage.getItem("wizzy_suggestions_cache")
      );
    } catch (e) {
      return data;
    }

    const pages = cache?.[query];
    if (!pages || !pages.length) return data;

    const wrapper = document.querySelector(
      ".wizzy-search-empty-results-wrapper.wizzy-suggestions"
    );
    if (!wrapper) return data;

    wrapper.style.display = "block";

    wrapper.innerHTML = `
      <div class="wizzy-custom-empty-results">
        <div class="wizzy-custom-header">
          <p>You searched for <strong>${query}</strong></p>
          <p>Here are some relevant results</p>
        </div>

        <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list">
          ${pages.map(page => {

            const type = page.url.includes("/blogs/")
              ? "Blog"
              : page.url.includes("/pages/")
              ? "Page"
              : "Page";

            return `
              <li class="grid__item">
                <a href="${page.url}" class="article-card-wrapper card-wrapper underline-links-hover" style="display:block; text-decoration:none;">
                  <div class="card card--card card--text ratio color-scheme-2" style="--ratio-percent: 100%;">
                    <div class="card__content">
                      <div class="card__information">
                        <h3 class="card__heading">
                          ${page.title}
                        </h3>
                      </div>
                      <div class="card__badge bottom left">
                        <span class="badge color-scheme-1">
                          ${type}
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            `;
          }).join("")}
        </ul>
      </div>
    `;

    return data;
  }
);




};


setTimeout(() => {
    const targetNode = document.querySelector('.wizzy-body-end-wrapper');

function updateBodyClass() {
  const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
  if (
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === 'flex'
  ) {
    document.body.classList.add('wizzy-autocomplete-open');
    document.getElementsByTagName('html')[0].classList.add('wizzy-autocomplete-open');
  } else {
    document.body.classList.remove('wizzy-autocomplete-open');
    document.getElementsByTagName('html')[0].classList.remove('wizzy-autocomplete-open');
  }
}

const wizzy_observer_config = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };
const callback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    updateBodyClass();
    break; // One update is enough per mutation batch
  }
};

const observer = new MutationObserver(callback);
// console.log("target node : ",targetNode);
if (targetNode) {
  // console.log("Inside node condition : ",targetNode);
  observer.observe(targetNode, wizzy_observer_config);
  updateBodyClass();
}
}, 1000);
